import { useEffect, useState } from 'react';
import ShipmentLegsRow from './shipmentLegRow';
import ShipmentATALegsRow from './shipmentATALegsRow';

interface Props {
  selectedRates: any;
  selectedLegsInfo: any;
  showInsuranceAndDiscount?: boolean;
  insuranceAmount?: any;
  discountAmount?: any;
  handleDeleteLeg?: any;
  isPriceHidden?: boolean;
  fees?: any;
  isMultiLeg?: boolean;
  existingLegs?: number;
}
const ShipmentATALegsTable = ({
  selectedRates,
  selectedLegsInfo,
  showInsuranceAndDiscount,
  insuranceAmount,
  discountAmount,
  handleDeleteLeg,
  isPriceHidden,
  fees,
  isMultiLeg,
  existingLegs,
}: Props) => {
  const [estCost, setEstCost] = useState<any>();
  const alreadyExistingLegs = existingLegs ? existingLegs : 0;

  useEffect(() => {
    if (selectedLegsInfo && selectedLegsInfo.length > 0) {
      let tax = 0;
      let subtotal = 0;
      let total = 0;

      selectedLegsInfo.forEach((legInfo: any) => {
        const ratesInfo = legInfo?.ratesInfo;

        if (ratesInfo && legInfo.leg !== 'A2') {
          const taxAmount = parseFloat(ratesInfo.tax);
          const totalAmount = parseFloat(ratesInfo.total);

          if (!isNaN(taxAmount) && !isNaN(totalAmount)) {
            tax += taxAmount;
            subtotal += totalAmount - taxAmount;
            total += totalAmount;
          }
        }
      });

      // Round to 2 decimal places
      let insurance = insuranceAmount ? parseFloat(insuranceAmount) : 0.0;
      let discount = discountAmount ? parseFloat(discountAmount) : 0.0;
      let quoteFee = fees ? parseFloat(fees) : 0.0;
      total = total + quoteFee + insurance - discount;
      tax = parseFloat(tax.toFixed(2));
      subtotal = parseFloat(subtotal.toFixed(2));
      total = parseFloat(total.toFixed(2));

      setEstCost({
        ...estCost,
        tax: tax,
        total: total,
        subTotal: subtotal,
        quoteFees: quoteFee,
      });
    }
  }, [selectedLegsInfo, insuranceAmount, discountAmount, fees]);

  return (
    <div className='ubbe-card h-auto mt-4'>
      <div className='ubbe-card-header'>
        <h5 className=' mb-0 GlobalBoxHead ms-3'>Shipment Legs</h5>
      </div>
      <div className='card-body h-auto'>
        <div className='row px-3 py-1'>
          <table className='table mb_0' id='shipment_legs_table'>
            <thead className='ubbe-table-header'>
              <tr>
                <th
                  className={`text-start align-middle ubbe-table-heading-text`}
                  scope='col'
                >
                  Leg
                </th>
                <th
                  className={`text-start align-middle ubbe-table-heading-text`}
                  scope='col'
                >
                  Route
                </th>
                <th
                  className={`text-start align-middle ubbe-table-heading-text`}
                  scope='col'
                >
                  Carrier
                </th>
                <th
                  className={`text-start align-middle ubbe-table-heading-text`}
                  scope='col'
                >
                  Est. Business Days
                </th>
                <th
                  className={`text-start align-middle ubbe-table-heading-text`}
                  scope='col'
                >
                  Subtotal
                </th>
                <th
                  className={`text-start align-middle ubbe-table-heading-text`}
                  scope='col'
                >
                  Tax
                </th>
                <th
                  className={`text-start align-middle ubbe-table-heading-text`}
                  scope='col'
                >
                  Total
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody id='shipment_legs_rows' className='bg-white'>
              {selectedLegsInfo &&
                selectedLegsInfo.length > 0 &&
                selectedLegsInfo.map(
                  (item: any, index: number) =>
                    item && (
                      <ShipmentATALegsRow
                        key={index} // Ensure you have a unique key for each element
                        legName={`L${index + 1 + alreadyExistingLegs}`}
                        leg={item}
                        route={item?.routing}
                        rateInfo={item?.ratesInfo}
                        isPriceHidden={isPriceHidden}
                        transitDays={item?.transit_days}
                        indexOfA1={selectedLegsInfo.findIndex(
                          (legItem: any) => legItem?.leg === 'A1'
                        )}
                        handleDeleteLeg={handleDeleteLeg}
                      />
                    )
                )}
              <tr>
                <td className='align-middle lex-18-400' colSpan={6}>
                  Insurance Amount
                </td>
                <td className='align-middle '>
                  {showInsuranceAndDiscount ? `$${insuranceAmount}` : '-'}
                </td>
                <td></td>
              </tr>
              <tr>
                <td className='align-middle lex-18-400' colSpan={6}>
                  Promo Code Discount
                </td>
                <td className='align-middle'>
                  {showInsuranceAndDiscount ? `-$${discountAmount}` : '-'}
                </td>
                <td></td>
              </tr>
              {fees && (
                <tr>
                  <td className='align-middle lex-18-400' colSpan={6}>
                    Fee
                  </td>
                  <td className='align-middle '>
                    ${isPriceHidden ? '-' : estCost?.quoteFees?.toFixed(2)}
                  </td>
                  <td></td>
                </tr>
              )}
              <tr style={{ backgroundColor: '#251163' }}>
                <td
                  className='align-middle'
                  colSpan={4}
                  style={{ color: '#fff' }}
                >
                  Total(Insurance amount & promo code applied)
                </td>
                <td className='align-middle' style={{ color: '#fff' }}>
                  ${isPriceHidden ? '-' : estCost?.subTotal?.toFixed(2)}
                </td>
                <td className='align-middle' style={{ color: '#fff' }}>
                  ${isPriceHidden ? '-' : estCost?.tax?.toFixed(2)}
                </td>
                <td className='align-middle' style={{ color: '#fff' }}>
                  ${isPriceHidden ? '-' : estCost?.total?.toFixed(2)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ShipmentATALegsTable;
